module.exports = __webpack_public_path__ + "ef9fa8be0fd316cc5018d170f036e2b0.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/trailer_preview-320.webp
// module id = 555
// module chunks = 0